var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer"},[_c('h4',{staticClass:"answer__question-text"},[_vm._v("\n\t\t"+_vm._s(_vm.questionText)+"\n\t")]),_vm._v(" "),_c('p',{staticClass:"answer__text"},[_vm._v(_vm._s(_vm.answerText))])])}
var staticRenderFns = []

export { render, staticRenderFns }